module.exports = __webpack_public_path__ + "img/汪紹銘律師.5e6e0a92.jpg";